<template>
  <v-card flat class="conservation-card">
    <v-container>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Residency</th>
            <th>Currency</th>
            <th>Amount</th>
            <th>Guests</th>
            <th>Countries</th>
            <th v-if="route !== 'NewPartnerBooking' && localData.user_type_id !== 'de8aa8a2'">Discount (%)</th>
            <th v-if="route !== 'NewPartnerBooking' && localData.user_type_id !== 'de8aa8a2'">Discount Reason</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fee, key) in allConservationFees" :key="key">
            <td>
              <v-tooltip top>
                <span slot="activator" class="residency-name">{{ fee.payment_person }}</span>
                <span>{{ fee.description }}</span>
              </v-tooltip>
            </td>
            <td class="currency-cell">{{ currency }}</td>
            <td class="amount-cell">{{ $roundOff((convert1(fee.payment_person_currency, fee.payment_person_amount).amount).toFixed(2)) }}</td>
            <td>
              <v-text-field label="Number"
                            type="number"
                            min="0"
                            step="1"
                            oninput="this.value = Math.max(0, this.value)"
                            v-model="allConservationFees[key].payment_guests"
                            dense
                            hide-details
                            class="compact-input"
                            @input="onGuestsChange(key)"
                            :disabled="route === 'PostponeBooking'"></v-text-field>
            </td>
            <td>
              <v-autocomplete v-model="allConservationFees[key].countries"
                              :items="allCountries"
                              item-text="name"
                              item-value="code"
                              multiple
                              chips
                              dense
                              hide-details
                              :disabled="route === 'PostponeBooking'"
                              @change="updateCountries(key, $event)"
                              class="compact-autocomplete"
                              :rules="getCountryRules(key)"
                              required></v-autocomplete>
            </td>
            <td v-if="route !== 'NewPartnerBooking' && localData.user_type_id !== 'de8aa8a2'">
              <v-text-field label="Discount (%)"
                            type="number"
                            :rules="limitRules"
                            min="0"
                            max="100"
                            step="any"
                            onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46"
                            oninput="if(parseFloat(this.value)>100) this.value=0"
                            onpaste="this.value = parseFloat(event.clipboardData.getData('text').replace(/[^0-9.]/g,'')) || 0; event.preventDefault()"
                            v-model.number="allConservationFees[key].payment_person_discount"
                            required
                            dense
                            hide-details
                            class="compact-input"
                            :disabled="route === 'PostponeBooking'"></v-text-field>
            </td>
            <td v-if="route !== 'NewPartnerBooking' && localData.user_type_id !== 'de8aa8a2'">
              <v-text-field label="Discount Reason"
                            v-model="allConservationFees[key].reason"
                            dense
                            hide-details
                            class="compact-input reason-input"
                            :disabled="route === 'PostponeBooking'"></v-text-field>
            </td>
            <td class="total-amount">
              <b>
                {{ $localCurrency }}
                {{
                  Math.ceil(
                    allConservationFees[key].payment_guests *
                      ((100 - allConservationFees[key].payment_person_discount) / 100) *
                      Math.ceil(
                        (convert1(
                          allConservationFees[key].payment_person_currency,
                          allConservationFees[key].payment_person_amount
                        ).amount).toFixed(2)
                      )
                  )
                }}
              </b>
            </td>
          </tr>
          <tr class="total-row">
            <td :colspan="route !== 'NewPartnerBooking' && localData.user_type_id !== 'de8aa8a2' ? 7 : 5"></td>
            <td class="total-amount">
              <h3>
                <strong>{{ $localCurrency }} {{ $roundOff(conservationTotal) }}</strong>
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    props: ['check_in', 'check_out'],
    name: 'conservation-fees',
    data() {
      return {
        limitRules: [
          v => v < 101 || 'Discount cannot be more than 100%'
        ],
        route: this.$route.name,
        gate_pass: {
          check_in: this.check_in,
          check_out: this.check_out
        },
        localData: JSON.parse(localStorage.getItem("unem") || '{}')
      }
    },
    created() {
      if (this.$route.name !== 'NewBooking') {
        this.$store.dispatch('get_all_conservation_fees')
        this.$store.dispatch("get_all_countries");
      }
    },
    computed: {
      currency() {
        return this.$store.state.CurrencyStore.browser_currency
      }
    },
    methods: {
      updateCountries(key, countries) {
        this.$emit('update-countries', { key, countries });
      },
      onGuestsChange(key) {
      },
      getCountryRules(key) {
        return [
          (value) => {
            const guests = this.allConservationFees[key].payment_guests || 0;
            if (guests > 0 && (!value || value.length === 0)) {
              return 'Countries are required when guests > 0';
            }
            return true;
          },
          (value) => {
            const guests = this.allConservationFees[key].payment_guests || 0;
            if (value && value.length > guests) {
              return `Cannot select more than ${guests} countries (one per guest)`;
            }
            return true;
          }
        ];
      }
    }
  }
</script>

<style scoped>

.conservation-card {
  background: #ffffff !important;
  border-radius: 12px;
  overflow: hidden;
}

  .conservation-container {
    padding: 8px 4px;
  }


  .conservation-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 6px;
    font-size: 13px;
    background: transparent;
  }

    .conservation-table thead th {
      background: #f5f7fb;
      color: #1a2332;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      padding: 12px 14px;
      border: none;
      border-bottom: 2px solid #e2e8f0;
      font-size: 12px;
    }

    .conservation-table tbody tr {
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      transition: box-shadow 0.2s ease, transform 0.1s ease;
    }

      .conservation-table tbody tr:hover {
        box-shadow: 0 4px 16px rgba(0,0,0,0.08);
        transform: translateY(-1px);
      }

      .conservation-table tbody tr:nth-child(even) {
        background: #fafbfc;
      }

    .conservation-table tbody td {
      padding: 10px 14px;
      border: none;
      vertical-align: middle;
      font-size: 13px;
      color: #2d3748;
    }

      .conservation-table tbody td:first-child {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .conservation-table tbody td:last-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }


  .compact-input {
    max-width: 80px;
    margin: 0;
  }

    .compact-input .v-input__control {
      min-height: 32px;
    }

    .compact-input .v-label {
      font-size: 11px;
      color: #718096;
    }

    .compact-input .v-text-field__slot input {
      font-size: 12px;
    }

  .compact-autocomplete {
    max-width: 160px;
    margin: 0;
  }

    .compact-autocomplete .v-input__control {
      min-height: 32px;
    }

    .compact-autocomplete .v-label {
      font-size: 11px;
    }

  .reason-input {
    max-width: 140px;
  }

  .v-autocomplete .v-chip {
    margin: 2px 4px 2px 0;
    font-size: 11px;
    height: 22px;
    background: #edf2f7;
  }

  .currency-cell {
    font-weight: 500;
    color: #4a5568;
  }

  .amount-cell {
    font-weight: 500;
    color: #2b6cb0;
  }

  .total-amount {
    text-align: right;
    font-weight: 600;
    color: #1a202c;
    padding-right: 18px !important;
    min-width: 100px;
  }

    .total-amount b {
      font-size: 14px;
    }

  .total-row td {
    background: transparent !important;
    box-shadow: none !important;
    padding-top: 12px;
  }

  .total-row h3 {
    font-size: 18px;
    margin: 0;
    color: #2d3748;
  }

  .residency-name {
    font-weight: 500;
    color: #2d3748;
    cursor: default;
  }

  .v-tooltip__content {
    font-size: 12px;
  }

  @media (max-width: 768px) {
    .conservation-table {
      font-size: 12px;
    }

    .compact-input {
      max-width: 60px;
    }

    .compact-autocomplete {
      max-width: 120px;
    }

    .reason-input {
      max-width: 100px;
    }
  }
</style>